/**
 * Lightweight input validators / normalizers used by the auth forms.
 */

/** Strip everything that isn't a digit (keeps a leading "+" out). */
export function normalizePhone(value = '') {
  return String(value).replace(/\D/g, '');
}

/**
 * A phone number is considered valid if it has 10–15 digits, which covers
 * local numbers and full E.164 numbers with a country code.
 */
export function isValidPhone(value) {
  const digits = normalizePhone(value);
  return digits.length >= 10 && digits.length <= 15;
}

/** OTP codes are 4–8 digits. */
export function isValidOtp(value, length) {
  const digits = normalizePhone(value);
  if (length) return digits.length === length;
  return digits.length >= 4 && digits.length <= 8;
}
